import { clearDeviceToken } from '../state/device-store.js';
import { clearLogs, logInfo } from '../state/log-store.js';
import { clearMediaCache } from '../storage/media-cache.js';

let revoking = false;

export async function handleSessionRevoked() {
  if (revoking) return;
  revoking = true;

  logInfo('Device session revoked — returning to pairing');

  const { stopPolling } = await import('../sync/poller.js');
  stopPolling();

  try {
    await clearMediaCache();
  } catch {
    /* best effort */
  }

  clearDeviceToken();
  clearLogs();

  const { setProgram } = await import('../state/program-store.js');
  setProgram(null);

  window.location.reload();
}

/** @internal test-only */
export function _resetSessionRevokedState() {
  revoking = false;
}
